import { RealworksProduct } from '@/api/model/realworks-product'

export class ProductCategory {
    constructor(
        public realworksCredentials: string,
        public id: string,
        public name: string,
        public realworksProductIds: Array<RealworksProduct['realworksId']> = [],
    ) {}

    static fromData(data: any) {
        return new ProductCategory(
            data.realworksCredentials,
            data.id,
            data.name,
            data.realworksProductIds.map(Number) || [],
        )
    }
}
